interface LargeOccupancyAffordabilityRankingEligibilityParams {
  rooms: Array<App.Occupants> | undefined
  searchType: App.SearchItem['searchType']
}

export function isLargeOccupancyAffordabilityRankingEligible({
  rooms,
  searchType,
}: LargeOccupancyAffordabilityRankingEligibilityParams): boolean {
  if (searchType === 'landmark' || searchType === 'property') return false
  if (rooms?.length !== 1) return false

  const [room] = rooms
  return room.adults < 3 && (room.children ?? 0) > 1
}
